/** @param {TemplateStringsArray} strings;  @param {...any} values;  @returns {string} */
export function html(strings, ...values) {
  return strings.reduce((result, string, i) => result + string + (values[i] ?? ''), '');
}


/** @param {any[]} arr;  @param {string} key; @param {boolean} ascending @returns {any[]} */
export function sortObjectArrayByKey(arr, key, ascending = true) {
  return ascending
    ? [...arr].sort((a, b) => {
      if (a[key] < b[key]) return -1;
      if (a[key] > b[key]) return 1;
      return 0;
    })
    : [...arr].sort((a, b) => {
      if (a[key] > b[key]) return -1;
      if (a[key] < b[key]) return 1;
      return 0;
    })
}


/** @param {number} x @param {number} N */
export const roundToNDecimalPlaces = (x, N) => Math.round(x * 10 ** N) / (10 ** N);


/** @param {string} word @param {number} quantity */
export function pluralise(word, quantity) {
  return quantity === 1 ? word : `${word}s`;
}


export function isNumeric(/** @type {unknown} */ n) /** @returns {boolean} */ {
  if (n === undefined || n === null) return false;
  return !isNaN(parseFloat(String(n))) && isFinite(Number(n));
}


/** @param {string} msg @param {string} bgColor @param {...any} args */
export function consoleLogColor(msg, bgColor = 'BlueViolet', ...args) {
  const styles = `background: ${bgColor}; color: white; font-weight: 500; padding: 4px; border-radius: 4px;`;
  console.log(`%c${msg}`, styles, ...args);
}


export const sleep = async (/** @type {number} */ ms) => new Promise((res) => setTimeout(res, ms));

/** 
 * @param {number} minVal 
 * @param {number} value 
 * @param {number} maxVal 
 */
export const clamp = (minVal, value, maxVal) => Math.min(maxVal, Math.max(minVal, value));